import React, { FunctionComponent, useEffect } from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, RouteComponentProps, Switch, withRouter } from 'react-router-dom';

import { Footer, Header, Layout } from '../../common/components';

import { PersonalHeader } from './components';
import { Cards } from './features/cards';
import { Discounts } from './features/discounts';
import { Orders } from './features/orders';
import { Settings } from './features/settings';
import { checkSessionActions } from '../user/ducks';
import { environment } from '../../environments/environment';

interface DispatchToProps {
    checkSession(): void;
}

type Props = RouteComponentProps & DispatchToProps;

export const PersonalComponent: FunctionComponent<Props> = ({ match, checkSession }) => {
    useEffect(() => {
        checkSession();
    });

    const shouldDisplay = (item: string) => {
        return environment.config.personalHeaderItems.includes(item);
    };

    return (
        <Layout>
            <Header />
            <PersonalHeader />
            <Switch>
                {shouldDisplay('cards') && (
                    <Route path={`${match.path}/cards`} component={Cards} />
                )}
                {shouldDisplay('orders') && (
                    <Route exact path={`${match.path}/orders`} component={Orders} />
                )}
                {shouldDisplay('discounts') && (
                    <Route exact path={`${match.path}/discounts`} component={Discounts} />
                )}
                {shouldDisplay('settings') && (
                    <Route exact path={`${match.path}/settings`} component={Settings} />
                )}
                <Redirect path={`${match.path}/`} to={`${match.path}/cards`} />
            </Switch>
            <Footer />
        </Layout>
    );
};

const mapDispatchToProps: DispatchToProps = {
    checkSession: checkSessionActions.request,
};

export const Personal = withRouter(
    connect(
        null,
        mapDispatchToProps
    )(PersonalComponent)
);
